import Appsignal from '@appsignal/javascript';
import { plugin } from '@appsignal/plugin-window-events';
import { APPSIGNAL_API_KEY, APPSIGNAL_ENVIRONMENT, APPSIGNAL_NAMESPACE, APPSIGNAL_APP_REVISION } from './Env';

export const appsignal = new Appsignal({
  key: APPSIGNAL_API_KEY,
  namespace: APPSIGNAL_NAMESPACE,
  revision: APPSIGNAL_APP_REVISION,
  ignoreErrors: [/401 Unauthorized/, /HTTP 401/, /Status: 401/, /code 401/],
});

appsignal.addDecorator((span) => {
  if (APPSIGNAL_ENVIRONMENT) {
    return span.setTags({ environment: APPSIGNAL_ENVIRONMENT });
  }
  return span;
});

appsignal.use(plugin({}));
